import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_7pzUtwM1Zj from "/vercel/path0/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_yfWm7jX06p from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import primevue_plugin_egKpok8Auk from "/vercel/path0/.nuxt/primevue-plugin.mjs";
import plugin_client_8fz26Kfk5j from "/vercel/path0/node_modules/nuxt-primevue/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/vercel/path0/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import _01_clerk_client_nfM35wJBSm from "/vercel/path0/plugins/01.clerk.client.js";
import _02_clerk_sync_client_TSdksB0djb from "/vercel/path0/plugins/02.clerk-sync.client.js";
import apiConfig_JK8NdyKDTh from "/vercel/path0/plugins/apiConfig.js";
import fontawesome_klhsrycjcK from "/vercel/path0/plugins/fontawesome.js";
import maska_r8BHBbSmHt from "/vercel/path0/plugins/maska.js";
import perfect_scrollbar_y9ZX9tg5GM from "/vercel/path0/plugins/perfect-scrollbar.js";
import qr_C2SXlru5RI from "/vercel/path0/plugins/qr.js";
import quill_client_BwKsKeKnJ1 from "/vercel/path0/plugins/quill.client.js";
import sentry_client_GoGQuZo4Et from "/vercel/path0/plugins/sentry.client.js";
import vue_html_to_paper_client_ByhaIE8sJd from "/vercel/path0/plugins/vue-html-to-paper.client.js";
import vue_smooth_dnd_uswnaseEwz from "/vercel/path0/plugins/vue-smooth-dnd.js";
import vue3_popper_client_d53GxV7ExF from "/vercel/path0/plugins/vue3-popper.client.js";
import vuethemask_client_hmzSMcSvm6 from "/vercel/path0/plugins/vuethemask.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_7pzUtwM1Zj,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_yfWm7jX06p,
  primevue_plugin_egKpok8Auk,
  plugin_client_8fz26Kfk5j,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  _01_clerk_client_nfM35wJBSm,
  _02_clerk_sync_client_TSdksB0djb,
  apiConfig_JK8NdyKDTh,
  fontawesome_klhsrycjcK,
  maska_r8BHBbSmHt,
  perfect_scrollbar_y9ZX9tg5GM,
  qr_C2SXlru5RI,
  quill_client_BwKsKeKnJ1,
  sentry_client_GoGQuZo4Et,
  vue_html_to_paper_client_ByhaIE8sJd,
  vue_smooth_dnd_uswnaseEwz,
  vue3_popper_client_d53GxV7ExF,
  vuethemask_client_hmzSMcSvm6
]